import update from 'immutability-helper';

// ----------------------------
// Constants
// ----------------------------
export const TOGGLE_SHOW_FREESEATING_POPUP = 'TOGGLE_SHOW_FREESEATING_POPUP';
export const SELECT_FREESEATING = 'SELECT_FREESEATING';
export const SET_SEAT_IN_SELECTION = 'SET_SEAT_IN_SELECTION';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';

export function toggleShowFreeSeatingPopup() {
	return {
		type: TOGGLE_SHOW_FREESEATING_POPUP,
	};
}

export function selectFreeSeating(seatIdentifier) {
	return {
		type: SELECT_FREESEATING,
		seatIdentifier,
	};
}

export function setSeatInSelection(seatIdentifier) {
	return {
		type: SET_SEAT_IN_SELECTION,
		seatIdentifier,
	};
}

export function addMessage(msg) {
	return {
		type: ADD_MESSAGE,
		msg,
	};
}

export function deleteMessage(msg) {
	return {
		type: DELETE_MESSAGE,
		msg,
	};
}

// ------------------------------------
// Action Creator
// ------------------------------------
export function addTimeoutMessage(msg) {
	return async (dispatch) => {
		setTimeout(() => dispatch(deleteMessage(msg)), 5000);
		return dispatch(addMessage(msg));
	};
}

// ----------------------------
// Action Handlers
// ----------------------------
const ACTION_HANDLERS = {
	[TOGGLE_SHOW_FREESEATING_POPUP]: (state) => update(state, {
		showFreeSeatingPopup: { $set: !state.showFreeSeatingPopup },
	}),
	[SELECT_FREESEATING]: (state, action) => update(state, {
		selectedFreeSeating: { $set: action.seatIdentifier },
	}),
	[SET_SEAT_IN_SELECTION]: (state, action) => update(state, {
		seatInSelection: { $set: action.seatIdentifier },
	}),
	[ADD_MESSAGE]: (state, action) => update(state, {
		messages: ((state.messages.indexOf(action.msg) === -1) ?
			{ $push: [action.msg] }
			: { $set: state.messages }),
	}),
	[DELETE_MESSAGE]: (state, action) => update(state, {
		messages: { $splice: [[state.messages.indexOf(action.msg), 1]] },
	}),
};

// ----------------------------
// Reducer
// ----------------------------
const initialState = {
	showFreeSeatingPopup: false,
	selectedFreeSeating: null,
	seatInSelection: null,
	messages: [],
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
